import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  finalize,
  map,
  switchMap,
  tap,
} from "rxjs/operators";
import { EventService } from "src/app/core/services/event.service";
import { ContactsService } from "src/app/pages/contacts/services/contacts.service";
import Swal from "sweetalert2";
import { ContactModel } from "../../../../models/contacts.model";
import { PermissionsService } from "src/app/core/services/permissions.service";

@Component({
  selector: "app-contacts-list-developments",
  templateUrl: "./contacts-list.component.html",
  styleUrls: ["./contacts-list.component.scss"],
})
export class ContactsListDevelopmentsComponent implements OnInit, OnDestroy {
  @Input() propertyContactsData: any;

  propertyId: any;
  queryField = new FormControl();
  hideElement: boolean = true;
  subscription: Subscription = new Subscription();
  countCheckSelected = 0;
  textAddOrUpdateModal: string = "Add Contacts";
  contactsTypes!: { id: number; description: string }[];

  contacts!: ContactModel[];
  contactsAuxCostumers!: ContactModel[];
  contactsAuxOwners!: ContactModel[];
  total: number = 0;
  totalAuxCostumers: number = 0;
  totalAuxOwners: number = 0;
  page: number = 1;
  pageSize: number = 10;
  startIndex: number = 1;
  endIndex: number = 10;
  filter: string = "";
  noresult: boolean = false;
  checkedList!: any[];
  masterSelected!: boolean;
  tab = 0;
  contactsCostumersDelete!: ContactModel[];
  contactsOwnersDelete!: ContactModel[];
  textAddContact = "Add Contact";
  @Input()
  loginUser!: { id?: string; role?: { id?: string; name?: string }, associatedUsers?: any };
  @Input()
  property: any;

  constructor(
    private eventService: EventService,
    private contactsService: ContactsService,
    public permissionsService: PermissionsService
  ) { }

  ngOnInit(): void {
    this.contactsAuxCostumers = [];
    this.contacts = [];
    this.contactsAuxOwners = [];
    this.contactsCostumersDelete = [];
    this.checkedList = [];
    this.tab = this.propertyContactsData.data.tab;

    // customers
    this.contactsAuxCostumers =
      this.propertyContactsData.data.costumers.costumers;
    this.totalAuxCostumers = this.propertyContactsData.data.costumers.total;
    this.contactsCostumersDelete =
      this.propertyContactsData.data.contactsCostumersDelete;

    // owners
    this.contactsAuxOwners = this.propertyContactsData.data.owners.owners;
    this.totalAuxOwners = this.propertyContactsData.data.owners.total;
    this.contactsOwnersDelete =
      this.propertyContactsData.data.contactsOwnersDelete;

    this.propertyId = this.propertyContactsData.data.propertyId;

    const subscriptionContactsTypes = this.contactsService
      .getContactsTypes()
      .subscribe({
        next: (data) => {
          this.contactsTypes = data;
        },
      });

    this.subscription.add(subscriptionContactsTypes);

    if (this.propertyContactsData.data.costumers && this.tab === 2) {
      this.hideElement = false;

      if (this.contactsAuxCostumers.length > 0) {
        this.contactsAuxCostumers.forEach((c, index) => {
          if (index < this.pageSize) {
            c.isSelected = false;
            this.contacts.push(c);
          }
        });
      }

      this.total = this.propertyContactsData.data.costumers.total;
      this.textAddContact = "Add Costumer";
    } else if (this.propertyContactsData.data.owners && this.tab === 1) {
      this.hideElement = false;

      if (this.contactsAuxOwners.length > 0) {
        this.contactsAuxOwners.forEach((c, index) => {
          if (index < this.pageSize) {
            c.isSelected = false;
            this.contacts.push(c);
          }
        });
      }

      this.total = this.propertyContactsData.data.owners.total;

      this.textAddContact = "Add Owners";
    }

    this.contacts.forEach((e) => {
      e.isAddToProperty = true;
    });

    this.searchData();

    const subscriptionAddContact = this.eventService.subscribe(
      "add-exist-contact-dev",
      (data) => {
        if (data.contacts && this.tab === 2) {
          this.contactsAuxCostumers = [];
          data.contacts.forEach((c: any) => {
            c.isSelected = false;
            this.contactsAuxCostumers.push(c);
          });

          this.contactsCostumersDelete = this.contactsCostumersDelete.filter(
            (c) => {
              const ca = this.contactsAuxCostumers.find((ca) => ca.id === c.id);
              return !ca;
            }
          );

          this.loadData();
        }
        if (data.contacts && this.tab === 1) {
          this.contactsAuxOwners = [];
          data.contacts.forEach((c: any) => {
            c.isSelected = false;
            this.contactsAuxOwners.push(c);
          });
          this.contactsOwnersDelete = this.contactsOwnersDelete.filter((c) => {
            const ca = this.contactsAuxOwners.find((ca) => ca.id === c.id);
            return !ca;
          });
          this.loadData();
        }
      }
    );
    this.subscription.add(subscriptionAddContact);

    this.paginate();
  }

  paginate() {
    this.startIndex = (this.page - 1) * this.pageSize + 1;
    this.endIndex = (this.page - 1) * this.pageSize + this.pageSize;
    if (this.endIndex > this.total) {
      this.endIndex = this.total;
    }
  }

  /**
   * Open modal
   * @param contacts
   */
  openModal() {
    if (this.tab == 2) {
      const subscriptionOpenModalContacts = this.eventService.broadcast(
        "open-modal-contacts-dev",
        {
          modal: "costumers",
          contactsTypes: this.contactsTypes,
          propertyId: this.propertyId,
          contactsAux: this.contactsAuxCostumers,
          contactsCostumersDelete: this.contactsCostumersDelete,
        }
      );

      this.subscription.add(subscriptionOpenModalContacts);
    } else if (this.tab == 1) {
      const subscriptionOpenModalContacts = this.eventService.broadcast(
        "open-modal-contacts-dev",
        {
          modal: "owners",
          contactsTypes: this.contactsTypes,
          propertyId: this.propertyId,
          contactsAux: this.contactsAuxOwners,
          contactsOwnersDelete: this.contactsOwnersDelete,
        }
      );

      this.subscription.add(subscriptionOpenModalContacts);
    }
  }

  loadData() {
    if (this.tab === 2) {
      const includeContacts = this.contactsAuxCostumers.filter(
        (c) => c.isNew === true && c.isAddToProperty === true
      );
      const includeContactsIds = includeContacts.map((c) => c.id);
      // const ignoreContacts = this.contactsCostumersDelete.filter(c => c.isNew === false && c.isAddToProperty === false);
      const ignoreContactsIds = this.contactsCostumersDelete.map((c) => c.id);
      const subscriptiongetAllCostumers = this.contactsService
        .getAllCostumersHasProperty(
          this.propertyId,
          this.page,
          this.filter,
          includeContactsIds,
          ignoreContactsIds
        )
        .pipe(
          tap(() => (this.hideElement = true)),
          tap((data) => (this.total = data.total)),
          map((data) => data.costumers),
          tap(() => this.paginate()),
          finalize(() => {
            this.hideElement = false;
          })
        )
        .subscribe((costumers) => {
          this.contacts = costumers;
          this.totalAuxCostumers = this.total;
          this.propertyContactsData.data.costumers.total =
            this.totalAuxCostumers;
          this.contacts.forEach((c) => {
            const ci = this.contactsAuxCostumers.find((ci) => ci.id === c.id);
            if (ci) {
              c.isSelected = ci.isSelected;
              c.isAddToProperty = ci.isAddToProperty;
              c.isNew = ci.isNew;
            } else {
              c.isSelected = false;
              c.isAddToProperty = true;
              c.isNew = false;
            }
          });

          this.contacts.forEach((c) => {
            const ca = this.contactsAuxCostumers.findIndex((ci) => {
              return ci.id === c.id;
            });
            if (ca === -1) this.contactsAuxCostumers.push(c);
          });
          this.contactsCostumersDelete = this.contactsCostumersDelete.filter(
            (c) => {
              const ca = this.contactsAuxCostumers.find((ca) => ca.id === c.id);
              return !ca;
            }
          );
          this.propertyContactsData.data.costumers.costumers =
            this.contactsAuxCostumers;
          this.propertyContactsData.data.costumers.total =
            this.totalAuxCostumers;
          this.propertyContactsData.data.contactsCostumersDelete =
            this.contactsCostumersDelete;
          this.getCheckedItemList();
          // this.queryField.patchValue('');
        });
      this.subscription.add(subscriptiongetAllCostumers);
    } else if (this.tab === 1) {
      const includeContacts = this.contactsAuxOwners.filter(
        (c) => c.isNew === true && c.isAddToProperty === true
      );
      const includeContactsIds = includeContacts.map((c) => c.id);
      // const ignoreContacts = this.contactsCostumersDelete.filter(c => c.isNew === false && c.isAddToProperty === false);
      const ignoreContactsIds = this.contactsOwnersDelete.map((c) => c.id);
      const subscriptiongetAllOwners = this.contactsService
        .getAllOwnersHasProperty(
          this.propertyId,
          this.page,
          this.filter,
          includeContactsIds,
          ignoreContactsIds
        )
        .pipe(
          tap(() => (this.hideElement = true)),
          tap((data) => (this.total = data.total)),
          map((data) => data.owners),
          tap(() => this.paginate()),
          finalize(() => {
            this.hideElement = false;
          })
        )
        .subscribe((owners) => {
          this.contacts = owners;
          this.totalAuxOwners = this.total;
          this.propertyContactsData.data.owners.total = this.totalAuxOwners;
          this.contacts.forEach((c) => {
            const ci = this.contactsAuxOwners.find((ci) => ci.id === c.id);
            if (ci) {
              c.isSelected = ci.isSelected;
              c.isAddToProperty = ci.isAddToProperty;
              c.isNew = ci.isNew;
            } else {
              c.isSelected = false;
              c.isAddToProperty = true;
              c.isNew = false;
            }
          });

          this.contacts.forEach((c) => {
            const ca = this.contactsAuxOwners.findIndex((ci) => {
              return ci.id === c.id;
            });
            if (ca === -1) this.contactsAuxOwners.push(c);
          });
          this.contactsOwnersDelete = this.contactsOwnersDelete.filter((c) => {
            const ca = this.contactsAuxOwners.find((ca) => ca.id === c.id);
            return !ca;
          });
          this.propertyContactsData.data.owners.owners = this.contactsAuxOwners;
          this.propertyContactsData.data.owners.total = this.totalAuxOwners;
          this.propertyContactsData.data.contactsOwnersDelete =
            this.contactsOwnersDelete;
          this.getCheckedItemList();
          // this.queryField.patchValue('');
        });
      this.subscription.add(subscriptiongetAllOwners);
    }
  }

  searchData() {
    if (this.tab === 2) {
      let includeContacts = this.contactsAuxCostumers.filter(
        (c) => c.isNew === true && c.isAddToProperty === true
      );
      let includeContactsIds = includeContacts.map((c) => c.id);
      let ignoreContactsIds = this.contactsCostumersDelete.map((c) => c.id);
      const subscriptiongetSearchCostumers = this.queryField.valueChanges
        .pipe(
          map((value) => value.trim()),
          // filter(value => value.length > 1),
          debounceTime(200),
          distinctUntilChanged(),
          tap((value) => {
            this.filter = value;
            includeContacts = this.contactsAuxCostumers.filter(
              (c) => c.isNew === true && c.isAddToProperty === true
            );
            includeContactsIds = includeContacts.map((c) => c.id);
            ignoreContactsIds = this.contactsCostumersDelete.map((c) => c.id);
          }),
          switchMap((value) =>
            this.contactsService.getAllCostumersHasProperty(
              this.propertyId,
              this.page,
              this.filter,
              includeContactsIds,
              ignoreContactsIds
            )
          ),
          tap((data) => (this.total = data.total)),
          map((data) => data.costumers),
          tap(() => this.paginate()),
          tap(() => (this.noresult = false))
        )
        .subscribe((costumers: any) => {
          this.contacts = costumers;
          if (this.total === 0) {
            this.noresult = true;
          }

          this.contacts.forEach((c) => {
            const ci = this.contactsAuxCostumers.find((ci) => ci.id === c.id);
            if (ci) {
              c.isSelected = ci.isSelected;
              c.isAddToProperty = ci.isAddToProperty;
              c.isNew = ci.isNew;
            } else {
              c.isSelected = false;
              c.isAddToProperty = true;
              c.isNew = false;
            }
          });
          this.getCheckedItemList();
        });
      this.subscription.add(subscriptiongetSearchCostumers);
    } else if (this.tab === 1) {
      let includeContacts = this.contactsAuxOwners.filter(
        (c) => c.isNew === true && c.isAddToProperty === true
      );
      let includeContactsIds = includeContacts.map((c) => c.id);
      let ignoreContactsIds = this.contactsOwnersDelete.map((c) => c.id);
      const subscriptiongetSearchOwners = this.queryField.valueChanges
        .pipe(
          map((value) => value.trim()),
          // filter(value => value.length > 1),
          debounceTime(200),
          distinctUntilChanged(),
          tap((value) => {
            this.filter = value;
            includeContacts = this.contactsAuxOwners.filter(
              (c) => c.isNew === true && c.isAddToProperty === true
            );
            includeContactsIds = includeContacts.map((c) => c.id);
            ignoreContactsIds = this.contactsOwnersDelete.map((c) => c.id);
          }),
          switchMap((value) =>
            this.contactsService.getAllOwnersHasProperty(
              this.propertyId,
              this.page,
              this.filter,
              includeContactsIds,
              ignoreContactsIds
            )
          ),
          tap((data) => (this.total = data.total)),
          map((data) => data.owners),
          tap(() => this.paginate()),
          tap(() => (this.noresult = false))
        )
        .subscribe((owners: any) => {
          this.contacts = owners;
          if (this.total === 0) {
            this.noresult = true;
          }

          this.contacts.forEach((c) => {
            const ci = this.contactsAuxOwners.find((ci) => ci.id === c.id);
            if (ci) {
              c.isSelected = ci.isSelected;
              c.isAddToProperty = ci.isAddToProperty;
              c.isNew = ci.isNew;
            } else {
              c.isSelected = false;
              c.isAddToProperty = true;
              c.isNew = false;
            }
          });
          this.getCheckedItemList();
        });
      this.subscription.add(subscriptiongetSearchOwners);
    }
  }

  refreshContacts() {
    this.loadData();
  }

  deleteMultiple() {
    if (this.checkedList?.length > 0) {
      Swal.fire({
        title: "You are about to delete a agent ?",
        text: "Deleting your agent will remove all of your information from our database.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Close",
      }).then((result) => {
        if (result.value) {
          this.checkedList.forEach((c) => {
            if (this.tab === 2) {
              this.contactsCostumersDelete.push(c);
              const cai = this.contacts.findIndex((ca) => ca.id === c.id);
              if (cai !== -1) {
                this.contacts.splice(cai, 1);
              }
              const ci = this.contactsAuxCostumers.findIndex(
                (ca) => ca.id === c.id
              );
              if (ci !== -1) {
                this.contactsAuxCostumers.splice(ci, 1);
              }
            } else if (this.tab === 1) {
              this.contactsOwnersDelete.push(c);
              const cai = this.contacts.findIndex((ca) => ca.id === c.id);
              if (cai !== -1) {
                this.contacts.splice(cai, 1);
              }
              const ci = this.contactsAuxOwners.findIndex(
                (ca) => ca.id === c.id
              );
              if (ci !== -1) {
                this.contactsAuxOwners.splice(ci, 1);
              }
            }
          });
          this.refreshContacts();
          this.checkedList = [];
          this.masterSelected = false;
          this.countCheckSelected = 0;
          this.eventService.broadcast(
            "count-check -selected-contacts-dev",
            this.countCheckSelected
          );
        }
      });
    }
  }

  /**
   * The master checkbox will check/uncheck all items
   * @param event
   */
  checkUncheckAll(event: any) {
    if (event.target.checked) {
      for (let i = 0; i < this.contacts.length; i++) {
        this.contacts[i].isSelected = event.target.checked;

        if (this.tab == 2) {
          const contAux = this.contactsAuxCostumers.find(
            (c) => c.id === this.contacts[i].id
          );

          if (contAux) contAux.isSelected = event.target.checked;
        }

        if (this.tab == 1) {
          const contAux = this.contactsAuxOwners.find(
            (c) => c.id === this.contacts[i].id
          );

          if (contAux) contAux.isSelected = event.target.checked;
        }

        const cont = this.checkedList.find((c) => c.id === this.contacts[i].id);

        if (!cont) {
          this.checkedList.push(this.contacts[i]);
        }
      }
    } else {
      for (let i = 0; i < this.contacts.length; i++) {
        this.contacts[i].isSelected = event.target.checked;

        if (this.tab == 2) {
          const contAux = this.contactsAuxCostumers.find(
            (c) => c.id === this.contacts[i].id
          );

          if (contAux) contAux.isSelected = event.target.checked;
        }

        if (this.tab == 1) {
          const contAux = this.contactsAuxOwners.find(
            (c) => c.id === this.contacts[i].id
          );

          if (contAux) contAux.isSelected = event.target.checked;
        }

        const pos = this.checkedList.findIndex(
          (c: any) => c.id === this.contacts[i].id
        );

        if (pos !== -1) {
          this.checkedList.splice(pos, 1);
        }
      }
    }

    this.getCheckedItemList();
    this.eventService.broadcast(
      "count-check -selected-contacts-dev",
      this.countCheckSelected
    );
  }

  /**
   * check/ uncheck all items
   * @param event
   * @param contact
   */
  checkUncheck(event: any, contact: any) {
    contact.isSelected = event.target.checked;
    if (this.tab === 2) {
      const contAux = this.contactsAuxCostumers.find(
        (c) => c.id === contact.id
      );
      if (contAux) contAux.isSelected = event.target.checked;
    }
    if (this.tab === 1) {
      const contAux = this.contactsAuxOwners.find((c) => c.id === contact.id);
      if (contAux) contAux.isSelected = event.target.checked;
    }

    if (event.target.checked) {
      this.checkedList.push(contact);
    } else {
      this.checkedList = this.checkedList.filter(
        (c: any) => c.id !== contact.id
      );
    }

    this.getCheckedItemList();
    this.eventService.broadcast(
      "count-check -selected-contacts-dev",
      this.countCheckSelected
    );
  }

  /**
   * Get List of Checked Items
   */
  getCheckedItemList() {
    this.countCheckSelected = 0;
    for (let i = 0; i < this.contacts.length; i++) {
      if (this.contacts[i].isSelected) {
        this.countCheckSelected++;
      }
    }
    if (this.countCheckSelected == this.contacts.length)
      this.masterSelected = true;
    else this.masterSelected = false;
  }

  /**
   * Confirmation delete user
   */
  confirm(contatct: ContactModel) {
    Swal.fire({
      title: "You are about to delete a costumer ?",
      text: "Deleting your costumer contact will remove all of your information from our database.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f46a6a",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Close",
    }).then((result) => {
      if (result.value) {
        const ca = this.contacts.find((c) => c.id === contatct.id);
        if (ca) {
          ca.isAddToProperty = false;
          ca.isNew = false;
          ca.isSelected = false;
        }
        if (this.tab === 2) {
          this.contactsCostumersDelete.push(contatct);
          const ci = this.contactsAuxCostumers.findIndex((ci) => {
            return ci.id === contatct.id;
          });
          if (ci !== -1) this.contactsAuxCostumers.splice(ci, 1);
        }
        if (this.tab === 1) {
          this.contactsOwnersDelete.push(contatct);
          const ci = this.contactsAuxOwners.findIndex((ci) => {
            return ci.id === contatct.id;
          });
          if (ci !== -1) this.contactsAuxOwners.splice(ci, 1);
        }
        this.refreshContacts();
        this.eventService.broadcast(
          "count-check -selected-contacts-dev",
          this.countCheckSelected
        );
      }
    });
  }

  /**
   * Title sweet alert
   * @param Error Msg modal content
   */
  errorMsg(errorMsg: string) {
    Swal.fire({
      title: "Oops...! Something went Wrong !",
      text: errorMsg,
      icon: "warning",
      confirmButtonColor: "rgb(54, 69, 116)",
      confirmButtonText: "Close",
    });
  }

  /**
   * show sweet alert success
   * @param msg string
   */
  showAlertSuccess(msg: string) {
    Swal.fire({
      //position: 'top-end',
      icon: "success",
      title: msg,
      showConfirmButton: false,
      timer: 1500,
    });
  }

  ngOnDestroy(): void {
    if (this.propertyContactsData.data.costumers.costumers) {
      this.propertyContactsData.data.costumers.costumers =
        this.contactsAuxCostumers;
      this.propertyContactsData.data.costumers.total = this.totalAuxCostumers;
      this.propertyContactsData.data.contactsCostumersDelete =
        this.contactsCostumersDelete;
    }
    if (this.propertyContactsData.data.owners.owners) {
      this.propertyContactsData.data.owners.owners = this.contactsAuxOwners;
      this.propertyContactsData.data.owners.total = this.totalAuxOwners;
      this.propertyContactsData.data.contactsOwnersDelete =
        this.contactsOwnersDelete;
    }

    this.subscription.unsubscribe();
  }
}
